export default () => ({
    bigImage: {
        maxWidth: "none! important",
    }
});